import Vue from 'vue'
import VueFlux from 'vue-flux'

Vue.component('Flux', VueFlux)
